import { observable, action } from 'mobx'

export default class {
  form
  constructor(form) {
    this.form = form
  }
  @observable selectInputValue = { key: '', value: [{ id: '', extra: '' }] }
  @action
  init = (key, value) => {
    this.selectInputValue.key = key
    this.selectInputValue.value = value || [{ id: '', extra: '' }]
  }
  @action
  handleChangeKey = (id, index) => {
    this.selectInputValue.value[index].id = id
  }
  @action
  handleChangeValue = (extra, index) => {
    this.selectInputValue.value[index].extra = extra
  }
  @action
  addInput = () => {
    this.selectInputValue.value = [
      ...this.selectInputValue.value,
      { id: '', extra: '' }
    ]
  }
  @action
  deleteLastValue = () => {
    if (this.selectInputValue.value.length > 1) {
      this.selectInputValue.value = this.selectInputValue.value.slice(0, -1)
      const deleteIndex = this.selectInputValue.value.length
      const key = this.selectInputValue.key
      this.form.setFieldsValue({
        [`${key}-${deleteIndex}-id`]: '',
        [`${key}-${deleteIndex}-extra`]: ''
      })
    }
  }
}
